/**
 * Bildergalerie im Projekt-Detail ([data-gallery]).
 *
 * Die Spur ist ein Scroll-Container mit Scroll-Snap — Wischen, Trackpad und
 * Tastatur schalten dadurch schon ohne JS weiter. Hier hängen nur die Pfeile,
 * die Punkte und die mitlaufende Bildlegende daran.
 *
 * Alles läuft über Delegation am document: das Projekt-Detail wird per fetch
 * ins Overlay gehängt, eine Initialisierung beim Laden würde jede nachgeladene
 * Galerie verpassen.
 */

const trackOf = (gallery) => gallery.querySelector('[data-gallery-track]')

/** Die Spur schnappt auf ganze Bildbreiten ein — daraus fällt der Index ab */
const indexOf = (track) => (track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0)

const smooth = () => !window.matchMedia('(prefers-reduced-motion: reduce)').matches

/**
 * Punkte, Pfeile und Legende auf das gerade sichtbare Bild ziehen.
 */
const sync = (gallery) => {
  const track = trackOf(gallery)

  if (!track) return

  const index = indexOf(track)
  const last = track.children.length - 1

  gallery.querySelector('[data-gallery-prev]')?.toggleAttribute('disabled', index <= 0)
  gallery.querySelector('[data-gallery-next]')?.toggleAttribute('disabled', index >= last)

  gallery.querySelectorAll('[data-gallery-dot]').forEach((dot, position) => {
    dot.classList.toggle('is-active', position === index)
    dot.setAttribute('aria-current', position === index ? 'true' : 'false')
  })

  gallery.querySelectorAll('[data-gallery-caption]').forEach((caption, position) => {
    caption.classList.toggle('is-active', position === index)
  })

  // lazysizes hängt am Fenster und bekommt den Seitwärts-Scroll der Spur nicht
  // mit — ohne diesen Anstoss bliebe das nächste Bild auf seinem Platzhalter
  // stehen. checkElems() ist lazysizes' gedrosselter Einstiegspunkt.
  window.lazySizes?.loader?.checkElems()
}

const goTo = (gallery, index) => {
  const track = trackOf(gallery)

  if (!track) return

  const target = Math.min(Math.max(index, 0), track.children.length - 1)

  track.scrollTo({ left: target * track.clientWidth, behavior: smooth() ? 'smooth' : 'instant' })
}

document.addEventListener('click', (event) => {
  const control = event.target.closest?.('[data-gallery-prev], [data-gallery-next], [data-gallery-dot]')
  const gallery = control?.closest('[data-gallery]')

  if (!gallery) return

  if (control.hasAttribute('data-gallery-dot')) {
    goTo(gallery, [...gallery.querySelectorAll('[data-gallery-dot]')].indexOf(control))
    return
  }

  const track = trackOf(gallery)

  if (track) goTo(gallery, indexOf(track) + (control.hasAttribute('data-gallery-next') ? 1 : -1))
})

// scroll steigt nicht auf; in der Capture-Phase am document ist es trotzdem zu
// hören — auch für Galerien, die erst per fetch dazukommen. sync() liest nur
// bereits berechnete Werte und schaltet Klassen, das verträgt jeden Frame.
document.addEventListener(
  'scroll',
  (event) => {
    const track = event.target

    if (!(track instanceof Element) || !track.matches('[data-gallery-track]')) return

    const gallery = track.closest('[data-gallery]')

    if (gallery) sync(gallery)
  },
  true,
)
